export default [
    {
        path: '/smeta',
        name: 'smeta',
        component: () => import('@/views/smeta/SmetasView.vue'),
        meta: {
            requiresAuth: true
        }
    }
]
